<template>
  <div class="rules-page">
    <section class="page-header">
      <div>
        <p class="kicker">Análise de Evidências - IA</p>
        <h1>Regras</h1>
      </div>
      <div class="header-actions">
        <v-btn outlined color="primary" @click="$router.push({ name: 'analise-evidencias-ia.painel' })">
          Voltar
        </v-btn>
        <v-btn color="primary" @click="novaRegra">
          Nova regra
        </v-btn>
      </div>
    </section>

    <v-card outlined class="mb-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2">
            <v-select v-model="filtros.tipoBase" :items="tiposBase" label="Base" outlined dense />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field v-model.number="filtros.ciclo" label="Ciclo" type="number" outlined dense />
          </v-col>
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="filtros.numeroQuesito"
              :items="quesitos"
              item-text="label"
              item-value="codigoQuesito"
              label="Quesito"
              outlined
              dense
              clearable
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="filtros.tipo" :items="tipos" label="Tipo" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="1">
            <v-select v-model="filtros.uf" :items="ufs" label="UF" outlined dense clearable />
          </v-col>
          <v-col cols="12" md="2" class="filter-actions">
            <v-btn color="primary" block :loading="loading" @click="carregarRegras">Filtrar</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="regras"
      :loading="loading"
      class="elevation-0"
      :items-per-page="15"
      no-data-text="Nenhuma regra encontrada."
    >
      <template v-slot:item.tipo="{ item }">
        <v-chip small dark :color="item.tipo === 'ACEITACAO' ? 'green' : 'orange'">
          {{ item.tipo }}
        </v-chip>
      </template>
      <template v-slot:item.textoRegra="{ item }">
        <div class="rule-text">{{ item.textoRegra }}</div>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon :color="item.ativo ? 'green' : 'grey'">{{ item.ativo ? 'mdi-check-circle' : 'mdi-close-circle' }}</v-icon>
      </template>
      <template v-slot:item.acoes="{ item }">
        <v-btn icon small title="Editar" @click="editarRegra(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small title="Desativar" :disabled="!item.ativo" @click="desativarRegra(item)">
          <v-icon small color="red">mdi-delete-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="760">
      <v-card>
        <v-card-title>{{ form.analiseEvidenciasIaRegraId ? "Editar regra" : "Nova regra" }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="3">
              <v-select v-model="form.tipoBase" :items="tiposBase" label="Base" outlined dense />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model.number="form.ciclo" label="Ciclo" type="number" outlined dense />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="form.tipo" :items="tipos" label="Tipo" outlined dense />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="form.escopo" :items="escopos" label="Escopo" outlined dense />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="form.uf" :items="ufs" label="UF" outlined dense :disabled="form.escopo === 'GERAL'" />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="form.numeroQuesito"
                :items="quesitos"
                item-text="label"
                item-value="codigoQuesito"
                label="Quesito"
                outlined
                dense
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model.number="form.prioridade" label="Prioridade" type="number" outlined dense />
            </v-col>
            <v-col cols="12">
              <v-text-field v-model="form.titulo" label="Título" outlined dense />
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="form.textoRegra" label="Regra" outlined rows="5" />
            </v-col>
            <v-col cols="12">
              <v-switch v-model="form.ativo" label="Ativa" inset />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="salvarRegra">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { atualUfDefinition } from "../../../helpers/utils";
import { analiseEvidenciasIaApi } from "../services/api";

function resolveUfAtual() {
  if (atualUfDefinition && atualUfDefinition.uf) return String(atualUfDefinition.uf).toUpperCase();
  return "RJ";
}

function emptyForm() {
  return {
    analiseEvidenciasIaRegraId: null,
    tipoBase: "selo",
    ciclo: 2026,
    numeroQuesito: "GERAL",
    tipo: "ACEITACAO",
    escopo: "UF",
    uf: resolveUfAtual(),
    titulo: "",
    textoRegra: "",
    prioridade: 100,
    ativo: true,
  };
}

export default {
  name: "AnaliseEvidenciasIaRegras",
  data() {
    return {
      loading: false,
      saving: false,
      dialog: false,
      filtrosBase: { quesitos: [], ufs: [], tiposBase: [] },
      regras: [],
      filtros: {
        tipoBase: "selo",
        ciclo: 2026,
        numeroQuesito: null,
        tipo: null,
        uf: resolveUfAtual(),
      },
      form: emptyForm(),
      tipos: [
        { text: "Aceitação", value: "ACEITACAO" },
        { text: "Rejeição", value: "REJEICAO" },
        { text: "Validador", value: "VALIDADOR" },
        { text: "Decisor", value: "DECISOR" },
      ],
      escopos: [
        { text: "UF", value: "UF" },
        { text: "Geral", value: "GERAL" },
      ],
      headers: [
        { text: "Base", value: "tipoBase" },
        { text: "Ciclo", value: "ciclo" },
        { text: "Quesito", value: "numeroQuesito" },
        { text: "Tipo", value: "tipo" },
        { text: "Escopo", value: "escopo" },
        { text: "Título", value: "titulo" },
        { text: "Regra", value: "textoRegra" },
        { text: "Ativa", value: "ativo" },
        { text: "", value: "acoes", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    tiposBase() {
      return this.filtrosBase.tiposBase && this.filtrosBase.tiposBase.length ? this.filtrosBase.tiposBase : ["selo", "cidade"];
    },
    ufs() {
      return this.filtrosBase.ufs && this.filtrosBase.ufs.length ? this.filtrosBase.ufs : [resolveUfAtual()];
    },
    quesitos() {
      const base = (this.filtrosBase.quesitos || []).map((q) => ({
        ...q,
        label: `${q.codigoQuesito} - ${q.tema || q.pergunta || ""}`,
      }));
      return [{ codigoQuesito: "GERAL", label: "GERAL - Todas" }, ...base];
    },
  },
  async mounted() {
    this.filtrosBase = await analiseEvidenciasIaApi.obterFiltros();
    await this.carregarRegras();
  },
  methods: {
    async carregarRegras() {
      this.loading = true;
      try {
        const data = await analiseEvidenciasIaApi.listarRegras(this.filtros);
        this.regras = data.regras || [];
      } finally {
        this.loading = false;
      }
    },
    novaRegra() {
      this.form = emptyForm();
      this.dialog = true;
    },
    editarRegra(item) {
      this.form = { ...item };
      this.dialog = true;
    },
    async salvarRegra() {
      this.saving = true;
      try {
        await analiseEvidenciasIaApi.salvarRegra(this.form);
        this.dialog = false;
        await this.carregarRegras();
      } finally {
        this.saving = false;
      }
    },
    async desativarRegra(item) {
      await analiseEvidenciasIaApi.desativarRegra(item.analiseEvidenciasIaRegraId);
      await this.carregarRegras();
    },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.kicker {
  margin: 0 0 4px;
  font-size: 12px;
  text-transform: uppercase;
  color: #546e7a;
}
.page-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
}
.header-actions {
  display: flex;
  gap: 8px;
}
.filter-actions {
  display: flex;
  align-items: flex-start;
}
.rule-text {
  max-width: 520px;
  white-space: normal;
}
</style>
